module.exports = __webpack_public_path__ + "media/images/french_soccer-9f4dc6f4.jpg";